import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_video-forge-417/artifacts/8amlg66h_Logo%20futuriste%20de%20ViralSynth.com.png";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="terms-page">
      <header className="border-b border-white/5">
        <div className="max-w-4xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="ViralSynth" className="w-36 h-auto" />
          </Link>
          <Link to="/" className="text-sm text-white/60 hover:text-white flex items-center gap-2">
            <ArrowLeft className="w-4 h-4" /> Retour
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="flex items-center gap-3 mb-8">
          <FileText className="w-8 h-8 text-[#FF3300]" />
          <h1 className="font-heading text-3xl font-medium">Conditions d'utilisation</h1>
        </div>
        <p className="text-sm text-white/40 mb-8">Derniere mise a jour : 24 avril 2026</p>

        <div className="space-y-6 text-white/70 text-sm leading-relaxed">
          <section>
            <h2 className="font-heading text-xl text-white mb-3">1. Acceptation des conditions</h2>
            <p>En utilisant ViralSynth ("le Service"), vous acceptez ces Conditions. Si vous n'acceptez pas, n'utilisez pas le Service.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">2. Description du Service</h2>
            <p>ViralSynth est une plateforme SaaS qui permet aux utilisateurs de creer automatiquement des videos generees par IA et de les publier sur leurs comptes sur les reseaux sociaux (YouTube, Instagram, X, TikTok, Facebook).</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">3. Compte utilisateur</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Vous devez avoir au moins 18 ans (ou age de majorite dans votre juridiction).</li>
              <li>Vous etes responsable de la confidentialite de votre compte.</li>
              <li>Vous ne devez pas partager votre compte avec d'autres personnes.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">4. Forfaits et paiements</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Les abonnements sont preleves mensuellement via Stripe.</li>
              <li>Les credits sont consommes par video generee.</li>
              <li>Les forfaits peuvent etre annules a tout moment (prise d'effet a la fin de la periode en cours).</li>
              <li>Aucun remboursement pour les periodes partielles, sauf obligation legale.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">5. Contenu utilisateur</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Vous conservez tous les droits sur le contenu que vous generez.</li>
              <li>Vous garantissez avoir les droits de publier sur les comptes sociaux connectes.</li>
              <li>ViralSynth ne revendique aucune propriete sur vos videos.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">6. Utilisation interdite</h2>
            <p>Il est strictement interdit d'utiliser ViralSynth pour :</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Generer ou publier du contenu illegal, haineux, discriminatoire, ou trompeur.</li>
              <li>Violer le copyright ou la propriete intellectuelle de tiers.</li>
              <li>Spammer, manipuler des algorithmes, ou creer des comptes factices.</li>
              <li>Generer du contenu NSFW, violent, ou ciblant des mineurs.</li>
              <li>Contourner les limites techniques ou les quotas.</li>
            </ul>
            <p className="mt-3">Toute violation entrainera la suspension ou suppression immediate du compte, sans remboursement.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">7. Integrations tierces</h2>
            <p>Les publications sur YouTube, Instagram, Facebook, X, TikTok sont soumises aux conditions d'utilisation de chaque plateforme. ViralSynth n'est pas responsable si un compte est suspendu par une plateforme tierce.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">8. Disponibilite du service</h2>
            <p>Nous visons une disponibilite de 99.5% mais ne garantissons pas une disponibilite ininterrompue. Des interruptions pour maintenance peuvent avoir lieu.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">9. Limitation de responsabilite</h2>
            <p>Dans la limite autorisee par la loi, ViralSynth ne saurait etre tenu responsable de :</p>
            <ul className="list-disc pl-6 space-y-2 mt-2">
              <li>Pertes indirectes, pertes de revenus, pertes d'audience.</li>
              <li>Actions des plateformes tierces (ban de compte, suppression de video).</li>
              <li>Contenu genere par l'IA qui serait incorrect ou inapproprie.</li>
              <li>Interruptions de service dues aux fournisseurs tiers.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">10. Resiliation</h2>
            <p>Vous pouvez resilier votre compte a tout moment depuis votre profil. Nous pouvons resilier un compte qui viole ces conditions, avec ou sans preavis.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">11. Modifications</h2>
            <p>Nous pouvons modifier ces conditions a tout moment. Les utilisateurs seront notifies par email et/ou via le site. L'usage continu apres modification vaut acceptation.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">12. Droit applicable</h2>
            <p>Ces conditions sont regies par le droit francais. Tout litige releve des tribunaux francais competents.</p>
          </section>

          <section>
            <h2 className="font-heading text-xl text-white mb-3">13. Contact</h2>
            <p>Pour toute question : <a href="mailto:info@viralsynth.com" className="text-[#FF3300] hover:underline">info@viralsynth.com</a></p>
          </section>
        </div>
      </main>
      <footer className="border-t border-white/5 mt-16">
        <div className="max-w-4xl mx-auto px-6 py-8 text-center text-xs text-white/30">
          &copy; 2026 ViralSynth. Tous droits reserves. &middot; <Link to="/privacy" className="hover:text-white/60">Politique de confidentialite</Link>
        </div>
      </footer>
    </div>
  );
}
